module.exports = __webpack_public_path__ + "img/30_45.daf6ebbf.png";